import { useQuery } from "@tanstack/react-query";
import httpClient from "@/config/axios";

export interface NurseAssignmentDebugItem {
  id: number;
  nurse_id: string;
  nurse_name?: string | null;
  source_group_id: string;
  target_group_id?: string | null;
  office_id: string;
  start_date: string;
  expected_end_date?: string | null;
  end_date?: string | null;
  reason: string;
  status: string;
  note?: string | null;
  target_team_id?: number | null;
  target_grade?: number | null;
  target_shift_types?: unknown[] | null;
}

export interface NurseAssignmentsDebugResponse {
  items: NurseAssignmentDebugItem[];
  counts: {
    active: number;
    completed: number;
    cancelled: number;
    on_hold: number;
  };
  total: number;
  applied_status?: string | null;
}

export function useNurseAssignmentsDebugQuery({
  groupId,
  enabled = true,
}: {
  groupId?: string | null;
  enabled?: boolean;
}) {
  const normalizedGroupId = (groupId ?? "").trim();

  return useQuery<NurseAssignmentsDebugResponse>({
    queryKey: ["debug", "nurse-assignments", normalizedGroupId],
    queryFn: async () =>
      httpClient.get<NurseAssignmentsDebugResponse>("/nurses/assignments", {
        params: {
          group_id: normalizedGroupId,
          status: "all",
        },
      }),
    enabled: enabled && normalizedGroupId.length > 0,
    staleTime: 0,
  });
}
